import { render, staticRenderFns } from "./feedbackSurvey.vue?vue&type=template&id=084d2012&scoped=true&"
import script from "./feedbackSurvey.vue?vue&type=script&lang=js&"
export * from "./feedbackSurvey.vue?vue&type=script&lang=js&"
import style0 from "./feedbackSurvey.vue?vue&type=style&index=0&id=084d2012&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084d2012",
  null
  
)

export default component.exports